// Scroll to error handler function
export function scrollToError(): void {
    const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
    if (firstElementWithError) {
        firstElementWithError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    if (!firstElementWithError) {
        const secondElementWithError = document.querySelector('.p-invalid');
        if (secondElementWithError) {
            secondElementWithError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
}
